import { init } from 'astro/prefetch';init()